


import React, { useState } from "react";
import GetMonths from "../../Dropdowns/getMonths";
import GetYears from "../../Dropdowns/getYears";
import GetDistricts from "../../Dropdowns/getDistricts";
import GetAfsoo from "../../Dropdowns/getAfsoo";
import GetFpssId from "../../Dropdowns/getFpssid";
import DateWise_Stockdetails from "./DateWise_Stockdetails";

const Date_wise_stock_details_int = ({ heading }) => {
  const [renderContent, setRenderContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [selectedDist, setSelectedDist] = useState("");
  const [loadingFpsId, setLoadingFpsId] = useState(false);
  const [selectedAfso, setSelectedAfso] = useState("");
  const [loadingAfso, setLoadingAfso] = useState(false);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  // ✅ Handle District change
  const handleDistrictChange = (dist_code) => {
    setSelectedDist(dist_code);
    setSelectedAfso(""); // Reset AFSO when district changes
  };

  // ✅ Handle AFSO change
  const handleAfsoChange = (afso_code) => {
    setSelectedAfso(afso_code);
  };

  const handleLoadingChange = (isLoading) => {
    setLoading(isLoading);
  };

  // ✅ Handle Submit with proper validation
  const handleSubmit = () => {
    const month = document.getElementById("month")?.value || "";
    const year = document.getElementById("year")?.value || "";
    const dist_code = document.getElementById("dist_code")?.value || "";
    const fps_id = document.getElementById("fps_id")?.value || "";
    const pos_ob_date = document.getElementById("pos_ob_date")?.value || selectedDate;

    // 🔍 Validation
    if (!month.trim()) {
      alert("Please select Month");
      return;
    }
    if (!year.trim()) {
      alert("Please select Year");
      return;
    }
    if (!dist_code.trim()) {
      alert("Please select District");
      return;
    }
    if (!selectedAfso.trim()) {
      alert("Please select AFSO");
      return;
    }
    if (!fps_id.trim()) {
      alert("Please select FPS ID");
      return;
    }
    if (!pos_ob_date.trim()) {
      alert("Please select Date");
      return;
    }

    // ✅ Render Data Component
    setRenderContent(null);
    setTimeout(() => {
      setRenderContent(
        <DateWise_Stockdetails
          month={month}
          year={year}
          dist_code={dist_code}
          fps_id={fps_id}
          pos_ob_date={pos_ob_date}
          heading={heading}
        />
      );
    }, 0);
  };

  return (
    <>
      <div className="wrapper row3">
        <div id="container">
          <div style={{ display: "flex", justifyContent: "center" }}>
            <br></br>
            <table width="0%">
              <thead>
                <tr className="tableheader">
                  <th colSpan={12}>Date wise Stock Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Month</td>
                  <td>
                    <GetMonths onLoadingChange={handleLoadingChange} />
                  </td>
                  <td>Year</td>
                  <td>
                    <GetYears onLoadingChange={handleLoadingChange} />
                  </td>
                  <td>District</td>
                  <td>
                    <GetDistricts
                      onLoadingChange={setLoadingDistricts}
                      onChange={handleDistrictChange}
                    />
                  </td>

                  <td>AFSO</td>
                  <td>
                    {selectedDist ? (
                      <GetAfsoo
                        dist_code={selectedDist}
                        onLoadingChange={setLoadingAfso}
                        onChange={handleAfsoChange}
                      />
                    ) : (
                      <select disabled>
                        <option value="">Select</option>
                      </select>
                    )}
                  </td>

                  <td>FPS</td>
                  <td>
                    {selectedAfso ? (
                      <GetFpssId
                        dist_code={selectedDist}
                        afso_code={selectedAfso}
                        onLoadingChange={setLoadingFpsId}
                      />
                    ) : (
                      <select disabled>
                        <option value="">Select</option>
                      </select>
                    )}
                  </td>

                  <td>Date</td>
                  <td>
                    <input
                      id="pos_ob_date"
                      type="date"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                    />
                  </td>
                </tr>

                <tr>
                  <td colSpan={12} align="center">
                    <button
                      onClick={handleSubmit}
                      className="button button2"
                      disabled={loading}
                    >
                      Submit
                    </button>
                    <button className="button button2">Back</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <br />
          <div id="loading" style={{ display: "none", textAlign: "center" }}>
            <img src="images/progress.gif" alt="Loading" />
          </div>
          <br />
          <div id="details1">{renderContent}</div>
        </div>
      </div>
    </>
  );
};

export default Date_wise_stock_details_int;
